
<mat-form-field class="odq-text-input full-width background pt-1">
  <select matNativeControl #inputField matInput  (change)="updateValue($event)" [disabled]="disabled">
    <option value=""></option>
    @for (year of range; track year) {
      <option value="{{year}}">{{year}}</option>
    }
  </select>
</mat-form-field>

